// extracted by mini-css-extract-plugin
export default {"root":"NC1J8"};